<template>
  <AuthTemplate>
    <h1>Восстановление пароля</h1>
    <div>
      <div>
        <div class="mb-20">
          <custom-input placeholder="Номер телефона" input_type="phone" v-model="form.phone" @change="errors.phone = null"/>
          <error-text :text="errors.phone"/>
        </div>
        <error-text/>
      </div>

      <button-component
          mb="10px"
          variant="filled"
          @click="recovery"
      >Подтвердить номер
      </button-component>
    </div>
  </AuthTemplate>
</template>

<script>
import ButtonComponent from '../../../components/ui/buttons/button-component'
import CustomInput from '../../../components/ui/inputs/custom-input'
import AuthTemplate from '../../../templates/AuthTemplate'
import ErrorText from "@/components/ui/text/error-text";

import {mapMutations} from 'vuex'

export default {
  name: 'Restore',
  components: {ButtonComponent, CustomInput, AuthTemplate, ErrorText},
  data() {
    return {
      form: {},
      errors: {},
    }
  },
  methods: {
    ...mapMutations(['openModal', 'setRecoveryData']),
    recovery() {
      this.form.phone = this.form.phone.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '');
      this.$api.auth.recovery.create(this.form)
          .then(({data}) => {
            this.setRecoveryData(data);
            this.openModal('recoveryVerify');
          }).catch(({response}) => this.errors = response.data.errors)
    },
    handlerSubmit() {
      this.openModal('newPassword')
    }
  }
}
</script>

<style scoped>
.mb-20 {
  margin-bottom: 20px;
}
</style>
